'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const assertNumberRange = (range) => {
    if (range.min > range.max) {
        throw new Error('Invalid number range: min must be lower than or equal to max');
    }
};
const isNumberInRange = (num, { min, max }) => {
    assertNumberRange({ min, max });
    return num >= min && num <= max;
};

exports.assertNumberRange = assertNumberRange;
exports.isNumberInRange = isNumberInRange;
//# sourceMappingURL=number-range.js.map
